import tokens from '@kluein/design-tokens';
import { Box, TextInput } from '@kluein/klue-ui';
import styled from 'styled-components';

export const UNIFIED_SEARCH_EXPANDED_WIDTH = 650;

export const StyledUnifiedSearchBox = styled(Box)`
  height: 36px;
  background-color: ${tokens.color.neutral.white.main};
  border-color: ${tokens.color.secondary[500]};
  outline: none;
  box-shadow: 0px 2px 8px 0px #f0e7ff;
  width: ${UNIFIED_SEARCH_EXPANDED_WIDTH}px;

  &:hover {
    border-color: ${tokens.color.secondary[500]};
    box-shadow: 0px 2px 8px 0px #f0e7ff;
  }

  &:focus,
  &:focus-visible {
    border-color: ${tokens.color.secondary[500]};
    outline-style: none;
    box-shadow: none;

    &:hover {
      border-color: ${tokens.color.secondary[500]};
      box-shadow: 0px 2px 8px 0px #f0e7ff;
    }
  }
`;

export const StyledUnifiedSearchInput = styled(TextInput)`
  background-color: ${tokens.color.neutral[100]};
  height: 100%;
  min-height: 33px;
  border: none;
  border-radius: 0;
  color: ${tokens.color.neutral[800]};
  padding-left: ${tokens.spacing.small};
  font-size: ${tokens.fontSize.bodyFont.medium};
  &:hover,
  &:focus {
    border: none;
  }
`;

export const StyledDropdownContainer = styled(Box)`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
`;

export const StyledDropdown = styled(Box)<{ $offset: number }>`
  position: absolute;
  top: 100%;
  left: ${({ $offset }) => $offset}px;
  z-index: 1000;
  background: ${tokens.color.neutral.white.main};
  border: 1px solid ${tokens.color.secondary[500]};
  border-radius: ${tokens.borderRadius.small};
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  margin-top: 2px;
  min-width: 200px;
`;

export const StyledDropdownItem = styled(Box)`
  padding: ${tokens.spacing.small};
  cursor: pointer;
  &:hover {
    background-color: ${tokens.color.neutral[100]};
  }
  &:first-child {
    border-top-left-radius: ${tokens.borderRadius.small};
    border-top-right-radius: ${tokens.borderRadius.small};
  }
  &:last-child {
    border-bottom-left-radius: ${tokens.borderRadius.small};
    border-bottom-right-radius: ${tokens.borderRadius.small};
  }
`;
